<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 20:14:44
 * @LastEditTime: 2019-06-26 20:14:44
 * @LastEditors: your name
 -->
<template>
  <div class="container">
    <div class="pageTitle">
      <el-button type="primary" @click="back">返回</el-button
      >礼品统计(统计下级经销商给门店的报销记录和门店核销记录)
    </div>

    <el-tabs v-model="active" type="card">
      <el-tab-pane label="门店核销统计" name="1">
        <verify />
      </el-tab-pane>
      <el-tab-pane label="门店报销统计" name="2">
        <expense />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import verify from "./components/verify.vue";
import expense from "./components/expense.vue";

export default {
  name: "",
  data() {
    return {
      active: "1",
      form1: {
        product_sn: "",
        product_name: "",
        role: "",
        isgift: "",
        start_time: "",
        end_time: "",
      },
    };
  },
  components: {
    verify,
    expense,
  },
  methods: {
    back() {
      this.$router.push({
        name: "lowerStoreManage",
        query: {
          id: this.$route.query.dealer_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
